// third party
import { createSlice } from "@reduxjs/toolkit";

// project imports
import axios from "utils/axios";
import { dispatch } from "../index";

// ==============================|| SLICE - SITE ||============================== //

const initialState = {
  error: null,
  sites: [],
  currentSite: null,
  loading: false,
};

const slice = createSlice({
  name: "site",
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },

    // SET LOADING
    setLoading(state, action) {
      state.loading = action.payload;
    },

    // GET SITES
    getSitesSuccess(state, action) {
      state.sites = action.payload;
      state.loading = false;
    },

    // GET SINGLE SITE
    getSiteSuccess(state, action) {
      state.currentSite = action.payload;
      state.loading = false;
    },

    // CREATE SITE
    createSiteSuccess(state, action) {
      state.sites.push(action.payload);
      state.loading = false;
    },

    // UPDATE SITE
    updateSiteSuccess(state, action) {
      const index = state.sites.findIndex(
        (site) => site.id === action.payload.id,
      );
      if (index !== -1) {
        state.sites[index] = action.payload;
      }
      state.currentSite = action.payload;
      state.loading = false;
    },

    // DELETE SITE
    deleteSiteSuccess(state, action) {
      state.sites = state.sites.filter((site) => site.id !== action.payload);
      state.loading = false;
    },

    // CLEAR CURRENT SITE
    clearCurrentSite(state) {
      state.currentSite = null;
    },
  },
});

// Reducer
export default slice.reducer;

// ==============================|| SLICE - SITE ACTIONS ||============================== //

export function getSites() {
  return async () => {
    try {
      dispatch(slice.actions.setLoading(true));
      const response = await axios.get("/sites");
      dispatch(slice.actions.getSitesSuccess(response.data.sites));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSiteById(siteId) {
  return async () => {
    try {
      dispatch(slice.actions.setLoading(true));
      const response = await axios.get(`/sites/${siteId}`);
      dispatch(slice.actions.getSiteSuccess(response.data.site));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createSite(siteData) {
  return async () => {
    try {
      dispatch(slice.actions.setLoading(true));
      const response = await axios.post("/sites", siteData);
      dispatch(slice.actions.createSiteSuccess(response.data.site));
      return response.data.site;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function updateSite(siteId, siteData) {
  return async () => {
    try {
      dispatch(slice.actions.setLoading(true));
      const response = await axios.put(`/sites/${siteId}`, siteData);
      dispatch(slice.actions.updateSiteSuccess(response.data.site));
      return response.data.site;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function deleteSite(siteId) {
  return async () => {
    try {
      dispatch(slice.actions.setLoading(true));
      await axios.delete(`/sites/${siteId}`);
      dispatch(slice.actions.deleteSiteSuccess(siteId));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function clearCurrentSite() {
  return (dispatch) => {
    dispatch(slice.actions.clearCurrentSite());
  };
}
